import React from "react";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import { connect } from "shared/src/stores/storeConnect";
import { ClosestStoreStore } from "../../stores/ClosestStoreStore";
import { StoreSelectionLocationModal } from "./globalheader/store/StoreSelectionLocationModal";
import { LoadingLocationModal } from "./globalheader/store/LoadingLocationModal";
import { trackStructuredEvent } from "shared/src/utils/TrackingUtil";
import StoreDataStore from "../../stores/StoreDataStore";

type Props = {
    storeName: string | null | undefined;
    showLoading: boolean;
};

type State = {
    showModal: boolean;
};

class StoreSelectionInfo extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            showModal: true
        };
    }

    hideLocation = () => {
        this.setState({ showModal: false });
    };

    cancelLocation = () => {
        this.setState({ showModal: false });
        trackStructuredEvent("storeSelector.geolocation", { tags: { status: "denied" } });
        const store = SessionStore.getCustomerStore();
        if (store) {
            SessionStore.setSelectedStoreId(store);
        }
    };

    acceptLocation = () => {
        this.setState({ showModal: false });
        ClosestStoreStore.maybeSwitchToClosestStore();
        trackStructuredEvent("storeSelector.geolocation", { tags: { status: "accepted" } });
    };

    render() {
        const shouldShow =
            this.state.showModal &&
            !SessionStore.isEmployee() &&
            CountryUtil.getOptionalConfig()?.shouldUseClosestStore &&
            !SessionStore.getSelectedStoreId();
        return (
            <div>
                <StoreSelectionLocationModal
                    onHide={this.hideLocation}
                    onAccept={this.acceptLocation}
                    onCancel={this.cancelLocation}
                    shouldShow={shouldShow}
                    storeName={this.props.storeName}
                />
                <LoadingLocationModal shouldShow={this.props.showLoading} />
            </div>
        );
    }
}

export default connect(
    {
        stores: [
            [
                StoreDataStore,
                (storeData: typeof StoreDataStore) => ({
                    storeName: storeData.getCurrentStoreName()
                })
            ],
            [
                ClosestStoreStore,
                (storeData: typeof ClosestStoreStore) => ({
                    showLoading: storeData.isLoading()
                })
            ]
        ]
    },
    StoreSelectionInfo
);
